module.exports = __webpack_public_path__ + "static/leftTextRightImageBGPlaceholder-8d28c02f5fb4b2f108e0199c1371437a.png";